module.exports = __webpack_public_path__ + "img/fcmb.d35f0bc1.jpg";